<template>
  <div>
    <div class="bg-wrapper hidden pc:block">
      <div class="bg mx-auto flex max-w-[1920px] items-center justify-center py-[76px]">
        <p class="text-[40px] font-bold text-neutral-950">성인 과정</p>
      </div>
    </div>

    <section class="pb-[70px] pt-[55px] pc:pb-[140px] pc:pt-[70px]">
      <div>
        <div class="show-list flex items-center justify-between bg-[#323740] p-2 pc:hidden">
          <div class="w-3"></div>
          <p class="text-sm font-bold text-white">과정 리스트 보기</p>
          <div class="w-3">
            <img src="@/assets/images/courseIntroduce/adult/arrow.png" alt="icon" class="show-arrow transition-all" />
          </div>
        </div>
        <ul class="lang-list flex pc:mx-auto pc:max-w-[1200px] pc:flex-col">
          <li class="w-[40%] bg-[#ececec] pc:w-full pc:bg-white">
            <ul class="gap-10 border-solid border-[#f1f1f1] pc:flex pc:border-b">
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultEng/PageAll')">
                영어
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#fb6930]"
                @click="goPage('/courseIntroduce/adultChi/pageAll')"
              >
                중국어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultJap/pageAll')">
                일본어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultEtc')">
                제2외국어
              </li>
            </ul>
          </li>
          <li class="w-[60%] pc:w-full">
            <ul class="sub-list gap-9 divide-y divide-solid divide-[#e9e9e9] pc:flex pc:divide-y-0">
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultChi/PageAll')"
              >
                전체 커리큘럼 맵
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#fb6930]"
                @click="goPage('/courseIntroduce/adultChi/page1')"
              >
                일반회화
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultChi/page2')"
              >
                비즈니스회화
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultChi/page3')"
              >
                토론회화
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultChi/page4')"
              >
                시험대비과정
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#666666]"
                @click="goPage('/courseIntroduce/adultChi/page5')"
              >
                테마과정
              </li>
            </ul>
          </li>
        </ul>
        <div class="pc-con-wrapper5">
          <div class="bg1 mb-7 flex flex-col items-center px-5 py-10 pc:mb-11 pc:py-[90px]">
            <p class="mb-2 text-center text-[35px] font-bold text-white">일반회화</p>
            <div class="mb-6 h-[2px] w-[72px] bg-[#fb6930]"></div>
            <p class="text-center text-white pc:text-2xl">
              실제 상황별 표현을 통해 기본기를 다지고<br />회화에 꼭 필요한 필수표현 습득으로 영어 자신감과 재미를 100%
              보장합니다.
            </p>
          </div>
          <div class="pc-con-wrapper4 px-5">
            <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book01.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">입문</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/CN01.pdf')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 입문 기초 중심</p>
                <p class="mb-1 text-sm text-[#535353]">
                  실제 중국인과의 만남에서 유용하게 사용할 수 있는 주요 표현을 위주로 주제로 하여 자연스럽게 중국어를 익힐 수 있는
                  입문 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#왕초보</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#성조부터회화까지</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book02.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">초급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="
                    goSite(
                      'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%A4%91%EC%8B%AC1.pdf'
                    )
                  "
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.1 기본 중심</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#중국어이해</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book03.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">초급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="
                    goSite(
                      'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%A4%91%EC%8B%AC2.pdf'
                    )
                  "
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.2 기본 중심</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#중국어이해</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book04.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">초급~중급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="
                    goSite(
                      'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%8B%AC%ED%99%943.pdf'
                    )
                  "
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.3 기본 심화</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#말하기연습</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book05.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">초급~중급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="
                    goSite(
                      'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%8B%AC%ED%99%944.pdf'
                    )
                  "
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.4 기본 중심</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#말하기연습</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book06.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">중급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/CN02.pdf')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.4 기본 심화</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#대화연습</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book07.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">중급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/CN03.pdf')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.5 스피킹중심</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#대화연습</li>
                </ul>
              </li>
              <li>
                <div class="relative mb-2.5">
                  <img src="@/assets/images/courseIntroduce/adult/chi/bg1-book08.png" alt="img" />
                  <p class="absolute bottom-5 right-0 bg-black/60 px-3 py-1 text-white">고급</p>
                </div>
                <p
                  class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                  @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/CN04.pdf')"
                >
                  미리보기
                </p>
                <p class="mb-1.5 font-medium text-[#111111]">팔선생 중국어 Vol.5 스피킹심화</p>
                <p class="mb-1 text-sm text-[#535353]">
                  중국어 문자 및 발음 체계, 기본적인 주제에 대해 말하기 연습과 이문화 학습을 동시에 하는 과정
                </p>
                <ul class="flex flex-wrap gap-1">
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#스피킹</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일반회화</li>
                  <li class="rounded-2xl bg-[#ececec] px-2 py-px text-sm">#일상대화</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const goPage = (url) => {
      location.href = url;
    };

    const goSite = (url) => {
      window.open(url, "_blank");
    };

    onMounted(() => {
      const showListButton = document.querySelector(".show-list");
      const arrowIcon = showListButton.querySelector(".show-arrow");
      const listToToggle = document.querySelector(".lang-list");
      const countryListItems = document.querySelectorAll(".sub-list li");

      showListButton.addEventListener("click", function () {
        if (listToToggle.style.display === "none") {
          listToToggle.style.display = "flex";
        } else {
          listToToggle.style.display = "none";
        }

        arrowIcon.classList.toggle("rotate-180");
      });

      countryListItems.forEach(function (item) {
        item.addEventListener("click", function () {
          listToToggle.style.display = "none";
          arrowIcon.classList.remove("rotate-180");
        });
      });
    });

    return {
      goPage,
      goSite,
    };
  },
};
</script>
<style lang="scss" scoped>
.bg1 {
  background: url(@/assets/images/courseIntroduce/adult/eng/bg1.png) no-repeat center / 1920px;
}
</style>
